﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="26"
  viewBox="0 0 21 26"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="translate(-1.000000, 1.000000)">
    <g transform="translate(2.000000, 0.000000)">
      <path
        d="M18.1,23.5 C18.6522847,23.5 19.1,23.0522847 19.1,22.5 L19.1,6.478
        C19.1007959,4.89281175 18.4716402,3.3722763 17.351024,2.25109751
        C16.2304079,1.12991872 14.7101884,0.5 13.125,0.5 L1.1,0.5
        C0.54771525,0.5 0.1,0.94771525 0.1,1.5 L0.1,22.5 C0.1,23.0522847
        0.54771525,23.5 1.1,23.5 L18.1,23.5 Z"
        id="Path" />
      <path
        d="M14.1,0.584 L14.1,4.5 C14.1,5.05228475 14.5477153,5.5 15.1,5.5
        L19.02,5.5"
        id="Path" />
      <path
        d="M6.1,18.5 C4.44314575,18.5 3.1,17.1568542 3.1,15.5 C3.1,13.8431458
        4.44314575,12.5 6.1,12.5"
        id="Path" />
      <path
        d="M11.1,12.4999721 L9.4,12.4999721 C8.82411571,12.496245
        8.31439533,12.8718282 8.14738749,13.4229772 C7.98037965,13.9741262
        8.19589265,14.5694679 8.677,14.886 L10.517,16.113 C10.9981186,16.4285953
        11.2145388,17.022921 11.0490106,17.573989 C10.8834825,18.1250569
        10.3753889,18.5017553 9.8,18.5000061 L8.1,18.5000061"
        id="Path" />
      <path
        d="M16.1,12.5 L16.1,14 C16.1,15.6227766 15.573666,17.2017787 14.6,18.5
        C13.626334,17.2017787 13.1,15.6227766 13.1,14 L13.1,12.5"
        id="Path" />
    </g>
  </g>
</svg>
